import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { useTheme } from 'foundations-theming/utils';
import { Form } from '../Form/Form';
import { FloatingFormProvider, useFloatingFormContext } from './FloatingFormProvider';
import { deepMerge } from '../../utils/deepMerge';
import { jsx as _jsx } from "react/jsx-runtime";
export const FloatingForm = _ref => {
  var _floatingFormContext$;
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const floatingFormContext = useFloatingFormContext();
  const theme = useTheme();
  const formStylesOverrides = deepMerge({
    borderBottomWidth: theme.borderWidth['100'],
    borderBottomStyle: 'solid',
    borderBottomColor: theme.color['fill-transparent-default'],
    borderTopWidth: theme.borderWidth['100'],
    borderTopStyle: 'solid',
    borderTopColor: theme.color['fill-transparent-default'],
    '& + *': {
      marginTop: `-${theme.space['25']}`
    }
  }, (_floatingFormContext$ = floatingFormContext === null || floatingFormContext === void 0 ? void 0 : floatingFormContext.formStylesOverrides) !== null && _floatingFormContext$ !== void 0 ? _floatingFormContext$ : {});
  return /*#__PURE__*/_jsx(FloatingFormProvider, {
    formStylesOverrides: formStylesOverrides,
    children: /*#__PURE__*/_jsx(Form, Object.assign({}, props, {
      children: children
    }))
  });
};
FloatingForm.displayName = 'FloatingForm';